<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="8">
            <el-form-item :label="$t('난수')">
              <el-input v-model="searchForm.tableUuid" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('TableMngForStoreSearch')"
        :size="size"
        @click="search"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >

      <el-popover
        v-if="checkAuthActionAccess('TableMngForStoreAdd')"
        trigger="click"
        :width="$device.mobile ? '95%' : 500">
        <el-button
          v-if="checkAuthActionAccess('TableMngForStoreAdd')"
          :size="size"
          slot="reference"
          icon="el-icon-circle-plus-outline"
          :disabled="btn.addDisabled"
          >{{ $t('추가') }}</el-button
        >

        <el-form :size="size" :label-position="$device.mobile ? `top` : `left`">
          <el-row :gutter="20">
            <el-col :span="9">
              <el-form-item :label="$t('시작번호')">
                <el-input-number v-model="startNum" :min="1" :max="999"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item :label="$t('종료번호')">
                <el-input-number v-model="endNum" :min="1" :max="999"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="padding-top: 42px">
              <el-button :size="size" @click="save" icon="el-icon-circle-plus-outline">{{ $t('생성') }}</el-button>
            </el-col>
          </el-row>
          <div style="padding-left: 5px; color: red">
            {{ $t('* 중복된 번호가 있으면 건너뛰고 생성 하지 않습니다.') }}
          </div>
        </el-form>
      </el-popover>

      <el-button
        v-if="checkAuthActionAccess('TableMngForStoreDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >

      <el-button :size="size" icon="el-icon-printer" @click="exportExcel" style="float: right">{{
        $t('QR 주소 출력')
      }}</el-button>
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @select="handleRowChecked"
      @select-all="handleRowChecked">
      <el-table-column
        :label="tableData.length.toString()"
        type="index"
        width="55"
        align="center"
        label-class-name="data_cnt"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>
      <el-table-column :label="$t('번호')" prop="tableNum" min-width="55" align="center"></el-table-column>

      <el-table-column :label="$t('번호QR')" min-width="180" align="center">
        <template slot-scope="scope">
          <div :id="'num_' + scope.row.tableNum"></div>
          <div>{{ getNumQrUrl(scope.row) }}</div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('난수')" prop="tableUuid" min-width="160" align="center"></el-table-column>

      <el-table-column :label="$t('난수QR')" min-width="300" align="center">
        <template slot-scope="scope">
          <div :id="'uuid_' + scope.row.tableUuid"></div>
          <div>{{ getUuidQrUrl(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="100"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import { initData } from '@/utils/constants'
import { downloadExcelFile } from '@/utils/downloadExcelFile'
import { logHttpFailure } from '@/plugins/http'
import { QR_WEB_URL } from '../utils/constants'

export default {
  mixins: [mainVueMixin],

  data: function () {
    const data = initData()
    data.url = '/tableMng/store'

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()

    data.formErrors = []

    data.startNum = 1
    data.endNum = 10

    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        tableUuid: '',
        useYn: 'Y',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        tableMngCd: 0,
        tableNum: 0,
        tableUuid: '',
        useYn: 'Y',
      }
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].tableMngCd
      }
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          var cnt = 5

          var tmp = setInterval(
            function () {
              this.showQr()
              cnt--
              if (0 == cnt) {
                clearInterval(tmp)
              }
            }.bind(this),
            500
          )
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('테이블 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function (index) {
      var params = {
        startNum: this.startNum,
        endNum: this.endNum,
      }

      this.mainVue.$axios.add(
        this.url,
        params,
        null,
        function (result) {
          this.mainVue.$message({ type: 'success', message: this.$t('생성 성공') })
          this.search()
        }.bind(this),
        true
      )
    },
    // 번호 QR
    getNumQrUrl: function (row) {
      return QR_WEB_URL + '/' + row.store.storeId + '/1/' + row.tableNum + '/I'
    },
    // 난수  QR
    getUuidQrUrl: function (row) {
      return QR_WEB_URL + '/' + row.store.storeId + '/1/' + row.tableUuid + '/I'
    },
    // 그리드 QR 생성
    showQr: function () {
      for (var i = 0, len = this.tableData.length; i < len; i++) {
        var row = this.tableData[i]

        if (null != document.getElementById('num_' + row.tableNum)) {
          var tmp = document.getElementById('num_' + row.tableNum)
          tmp.innerHTML = ''
          tmp.appendChild(
            new AraleQRCode({
              text: QR_WEB_URL + '/' + row.store.storeId + '/1/' + row.tableNum + '/I',
              size: 60,
            })
          )
        }

        if (null != document.getElementById('uuid_' + row.tableUuid)) {
          var tmp = document.getElementById('uuid_' + row.tableUuid)
          tmp.innerHTML = ''
          tmp.appendChild(
            new AraleQRCode({
              text: QR_WEB_URL + '/' + row.store.storeId + '/1/' + row.tableUuid + '/I',
              size: 60,
            })
          )
        }
      }

      if (this.$refs.table?.doLayout) {
        this.$refs.table?.doLayout()
      }
    },
    // 정보 출력
    exportExcel: async function () {
      const url = this.url + '/print'

      try {
        await downloadExcelFile(url)
      } catch (e) {
        this.mainVue.$message({ type: 'error', message: this.$t('엑셀 다운로드 실패') })

        logHttpFailure(e, 'excel download failed: ')
      }
    },
  },
}
</script>
